import request from '@/utils/request';

const path = 'api/v1';

const productsEntry = data => request({
  url: `${path}/products/storages/entry`,
  method: 'Post',
  data,
});

const cancelEntry = data => request({
  url: `${path}/products/storages/calcelentry`,
  method: 'Post',
  data,
});

const prodStorageList = data => request({
  url: `${path}/products/storages`,
  method: 'Get',
  params: data,
});

const storeDetail = data => request({
  url: `${path}/products/storages/detail`,
  method: 'Get',
  params: data,
});

const productsOprlist = data => request({
  url: `${path}/products/storages`,
  method: 'Get',
  params: data,
});

const productsOprlistV2 = data => request({
  url: `${path}/products/storagesv2`,
  method: 'Get',
  params: data,
});

const productsDetailById = data => request({
  url: `${path}/products/storages/detail`,
  method: 'Get',
  params: data,
});

const caseDetailByProductOrderNo = data => request({
  url: `${path}/send/products/order/caseDetailByProductOrderNo`,
  method: 'Get',
  params: data,
});

const splitPost = data => request({
  url: `${path}/products/storages/split`,
  method: 'Post',
  data,
});

const casesListGet = data => request({
  url: `${path}/products/cases`,
  method: 'Get',
  params: data,
});

const joinPost = data => request({
  url: `${path}/products/storages/join`,
  method: 'Post',
  data,
});

export {
  productsEntry,
  prodStorageList,
  cancelEntry,
  storeDetail,
  productsOprlist,
  productsOprlistV2,
  productsDetailById,
  caseDetailByProductOrderNo,
  splitPost,
  casesListGet,
  joinPost,
};
